import React from 'react'
import MendIOMappingForm from './MendIOMappingForm';
import MendIOCredentialsForm from './MendIOCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';
import { columnRenderArrayData, Sorters } from 'utils/tableUtils';

export default function MendIOConfigListing(props) {

    const columns = [
        {
            title: "Mend.IO Application",
            dataIndex: "applicationName",
            sorter: Sorters.STRING("applicationName"),
            render: columnRenderArrayData,
            width: 200
        },
    ]

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={MendIOMappingForm}
            CredentialsForm={MendIOCredentialsForm}
            extraColumns={columns}
            componentName="Project"
            componentKey="projectName"
        />
    )
}